export default function projectEmployees(state = [], action) {
    switch (action.type) {
        case "UPDATE_PROJECT_EMPLOYEES":
            return action.data
        default:
            return state
    }
}
